module.exports = __webpack_public_path__ + "img/En-Studio.d3afca42.gif";